
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/label_sets_picker/templates/label_set"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='multicomplete_row_header' tabindex=\"0\">\n  <div class='icon-back'>\n    <span class='sprite-global glyph toggle'></span>\n  </div>\n  <span class='multicomplete_name'></span>\n</div>\n<div class='multicomplete_wrapper'></div>\n";
},"useData":true});
    }).call(this);
  